import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../../Config";

const AddressEdit = ({ LedgerAccountDetail, refreshLedger }) => {

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState({});
    const [cities, setCities] = useState({});

    useEffect(() => {
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        const res = await axios.get(`${adminMainUrl}/api/country/list`);
        setCountries(res.data.data || []);
    };

    const fetchStates = async (countryId, index) => {

        const res = await axios.get(
            `${adminMainUrl}/api/state/list?country_id=${countryId}`
        );

        setStates((prev) => ({
            ...prev,
            [index]: res.data.data || [],
        }));
    };

    const fetchCities = async (stateId, index) => {

        const res = await axios.get(
            `${adminMainUrl}/api/city/list?state_id=${stateId}`
        );

        setCities((prev) => ({
            ...prev,
            [index]: res.data.data || [],
        }));
    };

    const formik = useFormik({
        enableReinitialize: true,

        initialValues: {
            addresses:
                LedgerAccountDetail?.ledger_account_addresses?.length > 0
                    ? LedgerAccountDetail.ledger_account_addresses.map((item) => ({
                        id: item.id,
                        address_line_one: item.address_line_one,
                        address_line_two: item.address_line_two,
                        country: item.country_id || "",
                        state: item.state_id || "",
                        city: item.city_id || "",
                        pincode: item.pincode
                    }))
                    : [
                        {
                            id: "",
                            address_line_one: "",
                            address_line_two: "",
                            country: "",
                            state: "",
                            city: "",
                            pincode: ""
                        },
                    ],
        },

        onSubmit: async (values) => {
            try {

                const formattedAddresses = values.addresses.map((address) => ({
                    id: address.id,
                    address_line_one: address.address_line_one,
                    address_line_two: address.address_line_two,
                    pincode: address.pincode,
                    country_id: address.country,
                    state_id: address.state,
                    city_id: address.city
                }));

                const payload = {
                    ledger_account_id: LedgerAccountDetail.id,
                    address: formattedAddresses,
                };

                await axios.post(
                    `${adminMainUrl}/api/account/update-ledger-account-address`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"),
                            user_id: Cookies.get("flexichain_user_id"),
                        },
                    }
                )
                    .then((res) => {
                        if (res.status === 200) {
                            toast.success(res.data.msg);
                            refreshLedger(LedgerAccountDetail.id)
                        }
                    })
                    .catch((err) => {

                        let err_msg = err.message;

                        if (err?.response?.data?.msg) {
                            err_msg = err.response.data.msg;
                        }

                        toast.error(err_msg);
                    });

            } catch {
                toast.error("Update failed");
            }
        },
    });

    useEffect(() => {

        const loadDependentData = async () => {

            if (!LedgerAccountDetail?.ledger_account_addresses) return;

            const updatedAddresses = [...formik.values.addresses];

            for (let index = 0; index < LedgerAccountDetail.ledger_account_addresses.length; index++) {

                const address = LedgerAccountDetail.ledger_account_addresses[index];

                updatedAddresses[index].country = address.country_id || "";

                if (address.country_id) {

                    const stateRes = await axios.get(
                        `${adminMainUrl}/api/state/list?country_id=${address.country_id}`
                    );

                    const stateList = stateRes.data.data || [];

                    setStates((prev) => ({
                        ...prev,
                        [index]: stateList,
                    }));

                    const validState = stateList.find((s) => s.id === address.state_id);

                    updatedAddresses[index].state = validState ? address.state_id : "";

                    if (validState) {

                        const cityRes = await axios.get(
                            `${adminMainUrl}/api/city/list?state_id=${address.state_id}`
                        );

                        const cityList = cityRes.data.data || [];

                        setCities((prev) => ({
                            ...prev,
                            [index]: cityList,
                        }));

                        const validCity = cityList.find((c) => c.id === address.city_id);

                        updatedAddresses[index].city = validCity ? address.city_id : "";
                    }
                }
            }

            formik.setFieldValue("addresses", updatedAddresses);
        };

        loadDependentData();

    }, [LedgerAccountDetail]);

    const addAddress = () => {

        formik.setFieldValue("addresses", [
            ...formik.values.addresses,
            {
                id: "",
                address_line_one: "",
                address_line_two: "",
                country: "",
                state: "",
                city: "",
                pincode: ""
            },
        ]);
    };

    const removeAddress = (index) => {

        if (formik.values.addresses.length > 1) {

            const updated = [...formik.values.addresses];
            updated.splice(index, 1);

            formik.setFieldValue("addresses", updated);
        }
    };

    return (
        <form onSubmit={formik.handleSubmit}>

            {formik.values.addresses.map((address, index) => (

                <div key={index} className="border p-3 mb-3">

                    <div className="row">

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Address Line 1</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`addresses.${index}.address_line_one`}
                                value={address.address_line_one}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Address Line 2</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`addresses.${index}.address_line_two`}
                                value={address.address_line_two}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Country</label>
                            <select
                                className="form-select"
                                value={address.country || ""}
                                onChange={(e) => {

                                    const countryId = e.target.value;

                                    formik.setFieldValue(`addresses.${index}.country`, countryId);
                                    formik.setFieldValue(`addresses.${index}.state`, "");
                                    formik.setFieldValue(`addresses.${index}.city`, "");

                                    fetchStates(countryId, index);
                                }}
                            >
                                <option value="">Select</option>

                                {countries.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">State</label>
                            <select
                                className="form-select"
                                value={address.state || ""}
                                onChange={(e) => {

                                    const stateId = e.target.value;

                                    formik.setFieldValue(`addresses.${index}.state`, stateId);
                                    formik.setFieldValue(`addresses.${index}.city`, "");

                                    fetchCities(stateId, index);
                                }}
                            >
                                <option value="">Select</option>

                                {(states[index] || []).map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">City</label>
                            <select
                                className="form-select"
                                name={`addresses.${index}.city`}
                                value={address.city || ""}
                                onChange={formik.handleChange}
                            >
                                <option value="">Select</option>

                                {(cities[index] || []).map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Pincode</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`addresses.${index}.pincode`}
                                value={address.pincode}
                                onChange={formik.handleChange}
                                maxLength={6}
                            />
                        </div>

                    </div>

                    <button
                        type="button"
                        className="btn btn-danger mt-2"
                        onClick={() => removeAddress(index)}
                    >
                        Delete Address
                    </button>

                </div>
            ))}

            <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={addAddress}
            >
               + Add More Address
            </button>

            <div className="mt-4">
                <button type="submit" className="btn btn-primary" style={{ float: "right" }}>
                    Save
                </button>
            </div>

        </form>
    );
};

export default AddressEdit;